import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import { useState, useEffect, useContext } from "react";
import "Static/main.css";
import { NavBar, Banner, Cart } from "CheckoutComponents";
import { CheckoutContext } from "Root/checkout/CheckoutRoutes";
import { useHistory } from "react-router-dom";
import { useCartHandlers, useFlavors } from "./hooks";
import { isInCart } from "../PersonalizationsPage";
import getAdditionalProducts from "./helpers/getAdditionalProducts";
function Checkout() {
    const history = useHistory();
    const [addonAttributes, setAddonAttributes] = useState(null);
    const showPrice = false;
    const { cart, setCart, userCart, updatingUserCart, addItemToCart, removeItemFromCart, error_message, updatingItems, name, bannerData, } = useContext(CheckoutContext);
    const { personalizedProducts, performanceBoosts, accessories } = useFlavors({
        error_message,
        addonAttributes,
        setAddonAttributes,
    });
    const proteinNotInCart = isInCart("protein", userCart) == null;
    const hydrationNotInCart = isInCart("hydration", userCart) == null;
    const preworkoutNotInCart = isInCart("preworkout", userCart) == null;
    function continueToCheckout() {
        if (proteinNotInCart && hydrationNotInCart && preworkoutNotInCart) {
            history.push("/checkout/summary/");
        }
        else {
            history.push("/checkout/personalizations/");
        }
    }
    const { addToCart, removeFromCart } = useCartHandlers({
        cart,
        setCart,
        updatingUserCart,
        addItemToCart,
        removeItemFromCart,
    });
    const additionalProducts = getAdditionalProducts({ cart, personalizedProducts, performanceBoosts, accessories });
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (_jsxs("div", { className: "checkout-container", children: [_jsx(NavBar, { active: 2, cart: cart, continue: () => continueToCheckout(), bannerData: bannerData }), _jsx(Banner, { theme: "light" }), _jsx(Cart, { cart: cart, removeFromCart: removeFromCart, addToCart: addToCart, userCart: userCart, cartItems: additionalProducts, updatingItems: updatingItems, accessoriesData: accessories, showPrice: showPrice, userName: name })] }));
}
export default Checkout;
